import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { CATEGORIES } from "../data/menu";
import { IMG } from "../data/site";
import { FadeUp, SectionHead } from "./Motion";

const MenuCategories = () => (
  <section id="menu" data-testid="menu-categories-section" className="mx-auto max-w-7xl px-5 py-32 md:px-10 md:py-40">
    <SectionHead
      index="02"
      kicker="The Menu"
      title={<>Thirteen ways to <em className="italic text-gold">fall in love</em></>}
    />

    <div className="grid grid-cols-2 gap-4 md:grid-cols-4 md:gap-5">
      {CATEGORIES.map((cat, i) => (
        <FadeUp
          key={cat.name}
          delay={(i % 4) * 0.08}
          className={i === 0 ? "col-span-2 row-span-2" : ""}
        >
          <motion.a
            href="#full-menu"
            data-testid={`category-card-${cat.name.toLowerCase().replace(/\s+/g, "-")}`}
            whileHover="hover"
            className="group relative block h-full min-h-[170px] overflow-hidden rounded-xl border border-white/10 md:min-h-[220px]"
          >
            <motion.img
              src={IMG.categories[cat.img]}
              alt={cat.name}
              loading="lazy"
              variants={{ hover: { scale: 1.08 } }}
              transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
              className="absolute inset-0 h-full w-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/25 to-transparent" />
            <div className="absolute inset-x-0 bottom-0 flex items-end justify-between p-5">
              <div>
                <h3 className={`font-serif text-white ${i === 0 ? "text-3xl md:text-5xl" : "text-xl md:text-2xl"}`}>{cat.name}</h3>
                <p className="mt-1 text-[11px] uppercase tracking-[0.22em] text-gold/90">{cat.count}</p>
              </div>
              <span className="glass rounded-full p-2 opacity-0 transition-all duration-500 group-hover:opacity-100">
                <ArrowUpRight size={15} className="text-gold" />
              </span>
            </div>
          </motion.a>
        </FadeUp>
      ))}
    </div>
  </section>
);

export default MenuCategories;
